import { post } from '../service';
import { UrlBuilder } from '../urlBuilder';

export const getReportstatus = async (payload) => {
  const builder = new UrlBuilder(`/get-report-status`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};

export const getReport = async (payload) => {
  const builder = new UrlBuilder(`/get-report`);
  try {
    const response = await post(builder.toString(), payload);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message);
  }
};
